//
// CrosstabMeasure.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../../BIRDModel";
import "../../common/ConditionReference";
import "../table/TableCell";
import "./CrosstabLabel";

var CrosstabMeasure = createModule("BIRD::CrosstabMeasure", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        variableName: 7,
        compactFormat: 2,
        name: 7,
        label: 1,
        styleClass: 7,
        conditions: [1],
        cell: 1,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default CrosstabMeasure;
